import { DefaultProps } from '../../../types/DefaultProps';
import { FiClockIcon } from '../../Icon';

import styles from './Time.module.scss';

import type { FC } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

export type ButtonProps = DefaultProps & {
  size: 'M' | 'S';
  text: string;
};

export const Time: FC<ButtonProps> = ({ text, size }) => {
  switch (size) {
    case 'M':
      return (
        <span className={styles['time-mid']}>
          <FiClockIcon size={14} />
          {text}
        </span>
      );
    case 'S':
      return (
        <span className={styles['time-min']}>
          <FiClockIcon size={14} />
          {text}
        </span>
      );
    default:
      return assertNever(size);
  }
};
